<template>
  <div id="app">

    <div class="signup-header">

      <div
        v-if="desktop"
        class="header-branding"
      >
        <a
          href="/"
          class="logo"
          :class="{ 'logo-order-offset': showOrder && desktop }"
        >toucanBox</a>
        <b class="decoration svg-confetti-yellow-signup"/>
        <b class="decoration svg-yellow-splat-signup"/>
        <b class="decoration svg-flash-yellow-signup"/>
        <b class="decoration svg-flash-blue-signup"/>
      </div>

      <transition name="fade">
        <a
          class="header-buttons back"
          @click="retreat"
          v-if="showBack"
          :class="{ 'menu-toggle': desktop }"
        >Back</a>
      </transition>

      <transition name="fade">
        <a
          v-if="showOrderToggle"
          class="header-buttons show-order-summary"
          :class="{ 'menu-toggle': desktop, active: showOrder }"
          @click="toggleOrder"
        >Show basket <i class="fa fa-shopping-cart"/></a>
      </transition>

      <div
        class="indicator-container"
        :class="{ 'header-order-offset': showOrder && desktop }"
      >
        <vue-progress-bar/>
      </div>

    </div>

    <!-- <transition name="fade">
      <div
        class="stage-indicator-wrapper"
      >
        <StepIndicator
          :step="step"
          :sequence-length="sequenceLength"
          @direct-navigate="directNavigate"
        />
      </div>
    </transition> -->

    <transition :name="transitionName">
      <keep-alive>
        <router-view
          :step="step"
          :desktop="desktop"
          :names="childrenNames"
          :order="showOrder"
          :children="childrenNames"
          :discount="discount"
          @next="advance"
          @update-signup-object="updateSignupObject"
          :class="{ 'page-order-offset': showOrder && desktop }"
        />
      </keep-alive>
    </transition>

    <transition :name="dropdownTransitionName">
      <div
        v-if="showOrder"
        class="order-summary"
      >
        <div
          class="screen-fader"
        />
        <div class="code-indicator-container">
          <div
            class="one-line-submit"
            v-if="!discount"
          >
            <input
              type="text"
              id="discount-code"
              placeholder="Add a discount code">
            <a
              class="input-button"
              @click="addDiscount"
            >Apply</a>
          </div>
          <div
            class="code-indicator indicator-block"
            v-if="discount"
          >
            <h4>Discount code applied</h4>
            <i
              class="fa fa-check"
              aria-hidden="true"
            />
          </div>
        </div>

        <Order
          :title="'Order summary'"
          :products="childrenNames.length"
          :names="childrenNames"
          :discount="discount"
        />

        <div class="summary-footer">
          <transition name="fade">
            <a
              class="footer-buttons modify"
              @click="modifyOrder"
              v-if="ableToModify"
            >Modify order</a>
          </transition>
          <a
            v-if="showOrderToggle"
            class="footer-buttons close"
            @click="toggleOrder"
          >Close
            <i
              class="fa"
              :class="{'fa-caret-up': !desktop, 'fa-caret-right': desktop }"
            />
          </a>
        </div>

      </div>
    </transition>

    <transition name="fade">
      <Paypal
        v-if="paypalVisible"
      />
    </transition>

    <transition name="fade">
      <Loader
        v-if="loaderVisible"
      />
    </transition>

  </div>
</template>

<script>
import * as smoothScroll from 'smoothscroll'

import { Sequence } from './router/sequence.js'

import Order from './components/library/order-table.vue'
import StepIndicator from './components/library/step-indicator.vue'
import Paypal from './components/library/paypal.vue'
import Loader from './components/library/loader.vue'

export default {
  name: 'App',
  components: {
    Order,
    StepIndicator,
    Paypal,
    Loader
  },
  data: function () {
    return {
      // Sequence related data
      step: 0,
      sequenceLength: Sequence.length,
      // UI state below
      transitionName: 'flow',
      desktop: false,
      showOrder: false,
      showBack: false,
      showOrderToggle: true,
      ableToModify: false,
      paypalVisible: false,
      loaderVisible: false,
      discount: false,
      dropdownTransitionName: 'dropdown',
      // root component level child name data to show in the order summary (would probably want to be from the store in the actual app)
      childrenNames: [{id: 0, name: ''}]
    }
  },
  beforeMount () {
    // sets discount mode
    let url = window.location.href
    let regex = new RegExp('[?&]' + 'code' + '(=([^&#]*)|&|#|$)')
    let results = regex.exec(url)
    if (!results) this.discount = false
    if (results) this.discount = true
    this.$events.$on('route-updated', (value) => {
      // event callback once a new route is mounted
      // value is the string name of the route
      // this allows the root component to know what stage in the sequence is currently visible
      console.log('route value, ', value)
      // Modifying the order doesn't make sense before the user has completed the children card
      if (value === 'address' || value === 'payment' || value === 'review') {
        this.ableToModify = true
      } else {
        this.ableToModify = false
      }
      // See what index the string is in the Sequence array
      this.step = Sequence.indexOf(value)

      // Can't go back on first or last step
      if (this.step === 0 || this.step === Sequence.length - 1) {
        this.showBack = false
      } else {
        this.showBack = true
      }

      console.log('current step', this.step)
      this.$Progress.set(100 * this.normalisedStep())
    })
    this.$events.$on('dismiss-order', (value) => {
      this.showOrder = false
    })
    this.$events.$on('added-child', (value) => {
      // For the prototype - to add children to the app root component data
      this.childrenNames.push({id: this.childrenNames.length, name: ''})
    })
    this.$events.$on('removed-child', (value) => {
      // For the prototype - remove child data at a specified index
      let index = value.position
      console.log('remove a child, index: ', value)
      this.childrenNames.splice(index, 1)
    })
    this.$events.$on('update-child', (value) => {
      // For the prototype - to edit app root component child data
      let index = value.position
      console.log('update child at index: ', index)
      this.childrenNames[index].name = value.name
    })
    this.$events.$on('show-paypal', (value) => {
      // Show temp paypal overlay step
      if (value) {
        this.paypalVisible = true
      } else {
        this.loaderVisible = true
        this.showOrder = false
        this.paypalVisible = false
        setTimeout(() => {
          this.loaderVisible = false
          this.advance()
        }, 2000)
      }
    })
    this.$events.$on('load-advance', (value) => {
      // Simulated async stripe transaction
      this.loaderVisible = true
      this.showOrder = false
      setTimeout(() => {
        this.loaderVisible = false
        this.advance()
      }, 2000)
    })
    this.$events.$on('review-modify', (value) => {
      this.transitionName = 'fade'
      this.$router.push('/' + value)
    })
  },
  mounted: function () {
    this.$nextTick(function () {
      // Listen for resize events in order to change this.desktop
      window.addEventListener('resize', this.reactToWindowChange)
      // Init
      this.reactToWindowChange(event)
    })
  },
  methods: {
    reactToWindowChange: function (event) {
      // Different state in desktop and mobile
      if (window.innerWidth >= 1024) {
        this.desktop = true
        this.dropdownTransitionName = 'slide'
      } else {
        this.desktop = false
        this.dropdownTransitionName = 'dropdown'
      }
      console.log('reacted to window change')
    },
    toggleOrder: function () {
      this.showOrder = !this.showOrder
      this.$events.$emit('order-summary-toggle', this.showOrder)
    },
    modifyOrder: function () {
      // fade to children card when modifyOrder clicked
      this.transitionName = 'fade'
      this.$router.push('/children')
      this.$events.$emit('modify-order', true)
      if (window.innerWidth <= 1024) {
        // dismiss order summary on mobile
        this.toggleOrder()
      }
    },
    addDiscount: function () {
      this.discount = true
    },
    advance: function () {
      // Goto next step method
      let testStep = this.step + 1
      // Must be able to go to a next step in the sequence
      if (typeof Sequence[testStep] !== 'undefined') {
        this.transitionName = 'flow'
        this.step += 1
        if (window.scrollY > 0) {
          // Scroll to top first, takes 500ms
          smoothScroll(0)
          setTimeout(() => {
            // Then transition the router
            this.$router.push(Sequence[this.step])
          }, 500)
        } else {
          this.$router.push(Sequence[this.step])
        }
      } else {
        console.log('already at last step')
      }
    },
    retreat: function () {
      if (this.showOrder) {
        this.showOrder = !this.showOrder
      } else if (this.step !== 0) {
        // Set the retreat transition
        this.transitionName = 'flow-retreat'
        this.step -= 1
        this.$router.push(Sequence[this.step])
      } else {
        this.$router.push('/')
      }
    },
    normalisedStep: function () {
      return this.step / (this.sequenceLength - 1)
    },
    updateSignupObject: function () {
      // Not used
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/App.vue